export default function flattenAvatars(payload) {
  return [
    ...payload.gentlemanAvatars,
    ...payload.ladyAvatars,
    ...payload.indistinctAvatars,
  ];
}